import { Box, Text, Tooltip } from '@wix/design-system';
import { parseDomain } from '@wix/domains-serverless-interface';
import React from 'react';
import { DomainSearchSuiteModule } from '../../module/domainSearchSuite.module';
import { ModalsModule } from '../../module/extensions/ModalsExtensions';
import { InfoCircleSmall } from '@wix/wix-ui-icons-common/odeditor';
import { useIsMobile } from '@wix/core-domain-search';
import commonStyles from '../common.scss';
export const ComBrRestriction = _ref => {
  let {
    domainName
  } = _ref;
  const {
    t,
    Trans
  } = DomainSearchSuiteModule.internals.useTranslations();
  const isMobile = useIsMobile();
  const {
    tld
  } = parseDomain(domainName);
  if (tld !== 'com.br') {
    return null;
  }
  const tooltipContent = /*#__PURE__*/React.createElement(Box, {
    padding: "SP3 SP4"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    light: true
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "domain_search_suite.domain_suggestions.com_br.restrictions_apply.tooltip_text",
    components: [/*#__PURE__*/React.createElement(Text, {
      weight: "bold",
      size: "small",
      light: true
    })]
  })));
  return /*#__PURE__*/React.createElement(Box, {
    gap: "2px",
    direction: "horizontal"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin",
    secondary: true
  }, t('domain_search_suite.domain_suggestions.com_br.restrictions_apply.text')), isMobile ? /*#__PURE__*/React.createElement(InfoCircleSmall, {
    className: commonStyles.infoIcon,
    "data-hook": "com-br-restriction-info-icon",
    onClick: () => {
      const {
        infoModal
      } = ModalsModule.internals.domainsSharedModalsController;
      infoModal.show({
        content: /*#__PURE__*/React.createElement(Box, {
          padding: "SP3 SP4"
        }, /*#__PURE__*/React.createElement(Text, {
          size: "small"
        }, /*#__PURE__*/React.createElement(Trans, {
          i18nKey: "domain_search_suite.domain_suggestions.com_br.restrictions_apply.tooltip_text",
          components: [/*#__PURE__*/React.createElement(Text, {
            weight: "bold",
            size: "small"
          })]
        })))
      });
    }
  }) : /*#__PURE__*/React.createElement(Tooltip, {
    maxWidth: "320px",
    appendTo: document.body,
    content: tooltipContent
  }, /*#__PURE__*/React.createElement(Box, {
    verticalAlign: "middle",
    height: "100%"
  }, /*#__PURE__*/React.createElement(InfoCircleSmall, {
    className: commonStyles.infoIcon
  }))));
};
//# sourceMappingURL=ComBrRestriction.js.map